import { sessionStore } from "@/Globals/Stores/SessionStore";
import { AutomaticWorkflowStep } from "../../BaseWorkflow/Steps/AutomaticWorkflowStep";
import { LoginWorkflowStepEnum } from "../LoginWorkflowStepEnum";

class LoadTitlesAndSpecialtiesCacheStep extends AutomaticWorkflowStep<LoginWorkflowStepEnum> {
    public constructor() {
        super(LoginWorkflowStepEnum.LoadTitlesAndSpecialtiesCache);
    }

    public isValid(): boolean {
        return cacheStore.TitlesAndSpecialtiesCache == undefined;
    }

    public isCompleted(): boolean {
        return !!cacheStore.TitlesAndSpecialtiesCache;
    }

    public execute(): void {
        sessionStore.action.loadTitlesAndSpecialtiesCache();
    }
}

export { LoadTitlesAndSpecialtiesCacheStep };
